/**
 * NIVARO · PLP helpers (collection + search).
 * Filtering itself is Horizon's facets.js; this file only adds:
 *  - <nv-price-range>: dual range slider mirroring the price text inputs
 *  - "Ver más / Ver menos" toggles on long filter lists
 */

class NvPriceRange extends HTMLElement {
  connectedCallback() {
    this.addEventListener('input', this.#onInput);
  }

  disconnectedCallback() {
    this.removeEventListener('input', this.#onInput);
  }

  get #inputs() {
    return {
      min: /** @type {HTMLInputElement | null} */ (this.querySelector('[data-nv-range="min"]')),
      max: /** @type {HTMLInputElement | null} */ (this.querySelector('[data-nv-range="max"]')),
    };
  }

  /** @param {Event} event */
  #onInput = (event) => {
    const { min, max } = this.#inputs;
    if (!min || !max) return;

    const rangeMax = Number(min.max) || 0;
    let low = Number(min.value);
    let high = Number(max.value);

    // Keep the thumbs from crossing.
    if (low > high) {
      if (event.target === min) {
        low = high;
        min.value = String(low);
      } else {
        high = low;
        max.value = String(high);
      }
    }

    if (rangeMax > 0) {
      this.style.setProperty('--nv-range-min', `${(low / rangeMax) * 100}%`);
      this.style.setProperty('--nv-range-max', `${(high / rangeMax) * 100}%`);
    }

    const facet = this.closest('price-facet-component');
    const minText = /** @type {HTMLInputElement | null} */ (facet?.querySelector('[ref="minInput"]'));
    const maxText = /** @type {HTMLInputElement | null} */ (facet?.querySelector('[ref="maxInput"]'));
    if (minText) minText.value = low > 0 ? String(low) : '';
    if (maxText) maxText.value = high < rangeMax ? String(high) : '';
    // The native `change` event of the range input (on release) bubbles to
    // price-facet-component[on:change] and applies the filter.
  };
}

if (!customElements.get('nv-price-range')) customElements.define('nv-price-range', NvPriceRange);

document.addEventListener('click', (event) => {
  const target = /** @type {HTMLElement | null} */ (event.target instanceof Element ? event.target : null);
  const button = target?.closest('[data-nv-facet-more]');
  if (!button) return;
  const group = button.closest('[data-nv-facet]');
  if (!group) return;
  const expanded = group.classList.toggle('is-expanded');
  button.setAttribute('aria-expanded', String(expanded));
});
